import type { SVGProps } from "react";
export interface WaterDropletOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WaterDropletOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WaterDropletOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 14v-.547c0-2.186-1.033-4.293-2.423-6.122-1.21-1.59-2.627-2.886-3.664-3.735l-.419-.335a.58.58 0 0 0-.65-.059l-.088.059c-.42.328-.943.759-1.508 1.277a1.125 1.125 0 1 1-1.52-1.657 28 28 0 0 1 1.642-1.393l.2-.142a2.83 2.83 0 0 1 3.31.142l.454.363c1.124.92 2.683 2.343 4.033 4.118 1.534 2.017 2.883 4.6 2.883 7.484v.546q0 .195-.01.39l-.01.114a1.126 1.126 0 0 1-2.236-.215zM2.205 2.205a1.125 1.125 0 0 1 1.505-.078l.085.078 18 18 .078.085a1.125 1.125 0 0 1-1.584 1.583l-.084-.078-1.59-1.589c-1.653 1.763-3.995 2.92-6.615 2.92-5.056 0-9.125-4.288-9.125-9.127v-.547c0-2.515 1.025-4.8 2.305-6.681L2.205 3.795l-.078-.085a1.125 1.125 0 0 1 .078-1.505m4.67 11.794a1.126 1.126 0 0 1 2.25 0 2.876 2.876 0 0 0 2.58 2.861l.41.02a1.125 1.125 0 0 1 0 2.24l-.115.005-.264-.007A5.126 5.126 0 0 1 6.875 14Zm-1.75 0c0 3.63 3.095 6.876 6.875 6.876 1.97 0 3.76-.882 5.024-2.26L6.803 8.394c-1 1.562-1.677 3.284-1.678 5.058z"
      />
    </svg>
  );
}
